import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ROUTES } from '../../../core/constants/routes.constants';
import { FeatureHighlight } from '../../interfaces/auth.type';

@Component({
  selector: 'app-auth-shell',
  imports: [RouterLink],
  templateUrl: './auth-shell.component.html',
  styleUrl: './auth-shell.component.scss'
})
export class AuthShellComponent {
  protected readonly routes = ROUTES;

  protected readonly features: FeatureHighlight[] = [
    { icon: '📖', title: 'Quran', subtitle: 'Read & Reflect', path: ROUTES.QURAN },
    { icon: '🕐', title: 'Prayer Times', subtitle: 'Stay on Time', path: ROUTES.PRAYER_TIMES },
    { icon: '📿', title: 'Duas & Azkar', subtitle: 'Daily Remembrance', path: ROUTES.DUAS_AZKAR },
    { icon: '🕌', title: 'Masjids', subtitle: 'Find Near You', path: ROUTES.MASJIDS }
  ];
}
